import { c as _c } from "react/compiler-runtime";
import { useFormikContext } from 'formik';
import { CLASS_TIMES_SAVE_FAILED_MESSAGE, SHOW_FIELD_ERROR_TEXT } from '../fieldErrorMessages';
import ClassTimeSlots, { useDegreeAwareClassTimes } from './ClassTimeSlots.js';
import ProgramSelect from './ProgramSelect.js';
import { splitClassTimeSlots } from './classTimes';
export const PROGRAM_QUESTION = 'Which program are you interested in applying for?';
export const PROGRAM_PLACEHOLDER = 'Select a program';

/**
 * Step 3 of the test variant ("Program of Interest"): the program select,
 * then, once a program is chosen, its class-time preference. The ticks live
 * under `classTimes` and stay when the program changes; the preferred and
 * optional split follows the program selected when the step is saved.
 *
 * `saveFailed` shows the class-times save failure on the slot group (a
 * validation error on the group shows first).
 *
 * @param {{
 *   degrees?: Array<{id: string, name: string, classTimesOffered?: import('@/types/ClassScheduleTimes').ClassSchedule}>,
 *   site?: string,
 *   autoFocus?: boolean,
 *   saveFailed?: boolean,
 * }} props
 */
function ProgramOfInterest(t0) {
  const $ = _c(17);
  const {
    degrees: t1,
    site,
    autoFocus: t2,
    saveFailed: t3
  } = t0;
  const degrees = t1 === undefined ? [] : t1;
  const autoFocus = t2 === undefined ? true : t2;
  const saveFailed = t3 === undefined ? false : t3;
  const formik = useFormikContext();
  const degreeAware = useDegreeAwareClassTimes();
  const degreeId = formik.values.degreeId;
  const degree = degreeId ? degrees.find(d => d.id === degreeId) : undefined;
  const {
    preferredSlots,
    optionalSlots
  } = splitClassTimeSlots(degree?.classTimesOffered, degreeAware);
  let t4;
  if ($[0] !== formik) {
    t4 = formik.getFieldMeta("classTimes");
    $[0] = formik;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  const classTimesMeta = t4;
  const showsValidationError = !!classTimesMeta.touched && !!classTimesMeta.error;
  let t5;
  if ($[2] !== autoFocus || $[3] !== degrees) {
    t5 = <ProgramSelect degrees={degrees} label={PROGRAM_QUESTION} emptyOptionLabel={PROGRAM_PLACEHOLDER} autoFocus={autoFocus} />;
    $[2] = autoFocus;
    $[3] = degrees;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== degree?.name || $[6] !== degreeAware || $[7] !== degreeId || $[8] !== optionalSlots || $[9] !== preferredSlots || $[10] !== saveFailed || $[11] !== showsValidationError || $[12] !== site) {
    t6 = !!degreeId && <ClassTimeSlots site={site} degreeName={degree?.name} degreeAware={degreeAware} preferredSlots={preferredSlots} optionalSlots={optionalSlots} layout="form" namePrefix="classTimes." name="classTimes" error={!showsValidationError && saveFailed && SHOW_FIELD_ERROR_TEXT ? CLASS_TIMES_SAVE_FAILED_MESSAGE : undefined} />;
    $[5] = degree?.name;
    $[6] = degreeAware;
    $[7] = degreeId;
    $[8] = optionalSlots;
    $[9] = preferredSlots;
    $[10] = saveFailed;
    $[11] = showsValidationError;
    $[12] = site;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t5 || $[15] !== t6) {
    t7 = <>{t5}{t6}</>;
    $[14] = t5;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  return t7;
}
export default ProgramOfInterest;